"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangedDatasetPackageSchema = exports.ExperimentDatasetRefSchema = void 0;
const z = require("zod");
exports.ExperimentDatasetRefSchema = z.object({
    id: z.string(),
    name: z.string(),
    version: z.number().int(),
});
exports.ChangedDatasetPackageSchema = z.object({
    packageId: z.string(),
    mpn: z.string(),
    previousSnapshotId: z.string(),
    snapshotId: z.string(),
});
//# sourceMappingURL=experiment-dataset.js.map